import { COMPANY_NAME_KO } from '../../utils/Utils'
import CustomerTitle from './components/CustomerTitle'
import CustomerMain from './CustomerMain'
import MapMain from 'pages/map/MapMain'

import './CustomerMain.scss'
import './CustomerServiceNetwork.scss'

/**
 * @file [고객지원]-[서비스 네트워크] 화면
 */
function CustomerServiceNetwork() {
    return (
        <>
            <CustomerMain />
            <div className="customer-body-wrap">
                <div className="customer-serviceNetwork-wrap-one">
                    <CustomerTitle
                        title="서비스 네트워크 검색"
                        sub={`가까운 곳 어디서나 쉽고 편리하게 ${COMPANY_NAME_KO}의 서비스를 이용할 수 있습니다.<br/>
                        EG CARE가 제공하는 서비스는 아래와 같습니다.`}
                    />
                </div>
                <MapMain isNewPage={false} type="network" />
            </div>
        </>
    )
}

export default CustomerServiceNetwork
